import { useState, useContext, useEffect, useCallback } from "react";
import get from "lodash/get";
import { isEmpty } from "lodash";
import { db } from "../../firebase";
import { AuthContext } from "../../Contexts/AuthContext";
import constant from "../../utils/constant";

const { DB_NAME } = constant;

// Fallback only used before Firestore responds (or if the doc is empty).
// Keep in sync with all-feature-access-user-list/data.individualUsers.
const normalizeEmails = (emails = []) =>
  (emails || [])
    .map((email) => String(email || "").trim().toLowerCase())
    .filter(Boolean);

const initialIndividualUsers = normalizeEmails([
  "testing1@gmail.com",
  "testing2@gmail.com",
  "amitpatel321@gmail.com",
  "dolly.ritesh@gmail.com",
  "Avani0427@gmail.com",
  "avani0427@gmail.com",
  "amitenggleader@gmail.com",
  // Active $27 Stripe subscribers grandfathered onto careerclawnew
  "awning-saber0c@icloud.com",
  "monikpatel15@gmail.com",
  "r.bhuva926@gmail.com",
]);
const initialWriterUsers = normalizeEmails([
  "testing2@gmail.com",
  "amitpatel321@gmail.com",
]);

const useFetchAllFeatureAccessUserList = () => {
  const { currentUser } = useContext(AuthContext);
  const uid = get(currentUser, "uid", null);
  const [isLoadingAllAccessUsers, setIsLoadingAllAccessUsers] = useState(false);
  const [allAccessIndividualUsers, setAllAccessIndividualUsers] = useState(
    initialIndividualUsers
  );
  const [allAccessWriterUsers, setAllAccessWriterUsers] =
    useState(initialWriterUsers);

  const fetchAllFeatureAccessUserList = useCallback(async () => {
    setIsLoadingAllAccessUsers(true);
    try {
      const doc = await db
        .collection(DB_NAME.ALL_FEATURE_ACCESS_USER_LIST)
        .doc("data")
        .get();
      const response = doc.data();

      if (!isEmpty(response)) {
        const { data } = response;
        if (!isEmpty(data?.individualUsers)) {
          setAllAccessIndividualUsers(normalizeEmails(data.individualUsers));
        }
        if (!isEmpty(data?.writerUsers)) {
          setAllAccessWriterUsers(normalizeEmails(data.writerUsers));
        }
      }
    } catch (err) {
      // Keep the fallback list so comps are not locked out if the read fails.
    } finally {
      setIsLoadingAllAccessUsers(false);
    }
  }, []);

  // Re-run when auth finishes loading. The old [] effect skipped the fetch
  // entirely whenever uid was still null on the first paint.
  useEffect(() => {
    if (uid) {
      fetchAllFeatureAccessUserList();
    }
  }, [uid, fetchAllFeatureAccessUserList]);

  return {
    isLoadingAllAccessUsers,
    allAccessIndividualUsers,
    allAccessWriterUsers,
  };
};

export default useFetchAllFeatureAccessUserList;
